import styled from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { cells } from '../../../styling/utils/grid';
import { text, fontFamilyBold } from '../../../styling/mixins/typography';


export const StyledLinkListSection = styled.section`
    padding-top: 2.4rem;
    padding-bottom: 3.2rem;

    ${breakpoint('medium')} {
      padding-top: 3.2rem;
      padding-bottom: 4rem;
    }

    ${breakpoint('large')} {
      padding-top: 4rem;
      padding-bottom: 4.8rem;
    }

    .cells-2, .cells-3, .cells-4 {
      ${cells(1)}
    }

    .cells-2 {
      ${breakpoint('medium')} {
        ${cells(2)}
      }    
    }

    .cells-3 {
      ${breakpoint('medium')} {
        ${cells(3)}
      }
    }

    .cells-4 {
      ${breakpoint('medium')} {
        ${cells(2)}
      }

      ${breakpoint('large')} {
        ${cells(4)}
      }
    }

   .link-list-block {
     &__header {
       display: flex;
       justify-content: space-between;
       margin-bottom: 2.4rem;
    }

    &__list {
      gap: 2.4rem;      

      &--item {

        h5 {
          ${text('xlarge')}
          ${fontFamilyBold};
          line-height: 2.2rem;
          text-transform: uppercase;
          margin-top: 2.4rem;
          margin-bottom: 3.7rem;
        }

        div {
          margin-bottom: 1.6rem;
        }

        img{
          width: 100%;
        }

        &__link {
          ${text('medium')}
          ${fontFamilyBold};
          line-height: 2.4rem;
          letter-spacing: 0.5px;
          text-decoration-line: underline;
          text-transform: uppercase;
        }
      }   
    }
  }
`;